<script>
  export let mode="info"
  export let close = null
  import {createEventDispatcher } from 'svelte';
  let alertBox
  const dispatch = createEventDispatcher()
  function handleClose(e){
    alertBox = e.target.closest(".salert") // bind:this not working in repl
    alertBox.style.maxHeight = alertBox.offsetHeight + "px"
    setTimeout(()=>{
      alertBox.classList.add("hiding")
    })
    setTimeout(()=>{
      dispatch('closed')
    },500)
  }
</script>

<div class="salert {mode}" role="alert"> 
  {#if close}
    <button type="button" class="close" on:click={handleClose} aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  {/if}
  <slot />
</div>

<style>
  *{
    box-sizing: border-box;
  }
  .salert{
    position: relative;
    padding: 10px 15px;
    margin-bottom: 1rem;
    border: 1px solid rgba(0,0,0,0.05);
    border-radius: .25rem;
    transition:max-height 0.5s,opacity 0.5s,padding 0.5s,margin-bottom 0.5s,transform 0.5s;
    background:var(--d-primary,#2299ee);
    color:rgba(0,0,0,0.7);
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7));
    line-height:1.5;
  }
  .salert :global(h1),.salert :global(h2),.salert :global(h3),.salert :global(h4),.salert :global(h5),.salert :global(h6),.salert :global(p)
  {
    margin:0 0 10px 0;
  }
  .info{background-color:var(--d-info,#17a2b8);}
  .success{background-color:var(--d-success,#28a745)}
  .warning{background-color:var(--d-warning,#ffc107)}
  .danger{background-color:var(--d-danger,#dc3545)}
  .dark{background-color:var(--d-dark,#343a40)}

  .salert:first-child{
    margin-top:0!important
  }

  .salert:last-child{
    margin-bottom:0!important
  }
  .close{
    background:transparent;
    border:0px;
    font-size:24px;
    font-weight:bold;
    position:absolute;
    right:0px;
    top:0px;
    padding:4px 10px;
    cursor:pointer;
    opacity:0.5
  }
  .close:hover{
    opacity:1;
  }
  .hiding{
    overflow:hidden;
    max-height:0!important;
    opacity:0;
    padding:0 15px;
    margin-bottom:0;
    transform: scale3d(0,0,0.1)
  }
</style>